import { mapGetters } from "vuex";
import { store } from "@sim/store/store";
import api from "@sim/services/api";
import router from "@sim/router";
import localStorage from "@sim/services/storage";
import SingleStep from "@sim/components/Partials/SingleStep.vue";
import StepWrapper from "@sim/components/Partials/StepWrapper.vue";
import stepsMixin from "@sim/mixins/stepsMixin";
import _ from "lodash";
import { transformErrors } from '@checkout/services/errors';

export default {

  mixins: [stepsMixin],

  components: {
    SingleStep,
    StepWrapper,
  },

  data() {
    return {
      
      form: {
        firstName: "",
        lastName: "",
        shopAddress: "",
        shopNumber: "",
        shopCity: "",
        shopPostalCode: "",
        personGivingSIM: "",
        placeOfBuyingSIM: "",
        shopName: "",
        shopAddress: "",
        image: "",
        receivingDate: "",
        token: "",
      },
      simGift: false,
      errors: [],
      skipJumping: false,
      prefix: localStorage.get('locale', true) ? '/'+localStorage.get('locale', true) : '/de',  
    };
  },

  computed: {
    ...mapGetters(["steps"]),

    isStep5() {
      return this.$route.meta.stepNumber === "5";
    },
  },

  methods: {
    uploadImage(e) {
      if (!e.target.files.length) {
        return;
      }

      this.form.image = e.target.files[0];
    },

    prepareStep5() {
      api
        .get("/public-api/prepare-sim/5/" + localStorage.get("page-step", true))
        .then((response) => {
          this.form = response.data.user;

          let token = localStorage.get("token", true);

          if (token !== null) {
            this.form.token = token;
          }
        })
        .catch((error) => {
          this.$swal(this.$i18nApi.t("messages.error"));
          router.push(this.prefix+"/sim-registration/1");
        });
    },

    updateCustomer: function () {
      store.commit("TOGGLE_PRELOADER_AXIOS_REQUEST_SCREEN_TO_TRUE");
      this.errors = [];
      
      let formData = new FormData();
      Object.keys(this.form).forEach(key => formData.append(key, this.form[key]));

      api.post('/public-api/sim-registration', formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
        .then((response) => {
            store.commit('TOGGLE_PRELOADER_AXIOS_REQUEST_SCREEN_TO_FALSE');
            
            if (response.data.hasOwnProperty("paybox") && response.data.paybox != '' && response.data.paybox != null) {
              window.location.href = response.data.paybox;
            } else {
              router.push(this.prefix+"/sim-registration/6");
            }
        })
        .catch(error => {
            store.commit('TOGGLE_PRELOADER_AXIOS_REQUEST_SCREEN_TO_FALSE');
            this.$swal(this.$i18nApi.t('messages.error'));
            if (error.response.status === 422) {
              this.errors = transformErrors(error.response.data.errors);
            }

            if (error.response.data.hasOwnProperty("username")) {
                var alertContent = document.createElement('span');
                alertContent.innerHTML=this.$i18nApi.t("userExists");
                this.$swal({
                  content: alertContent,
                  icon: "warning",
                });
            }

            if (error.response.data.hasOwnProperty("bad-address")) {
                this.$swal(this.$i18nApi.t("badAddress"));
            }

            if (error.response.data.hasOwnProperty("error")) {
                this.$swal(this.$i18nApi.t("messages.error"));
            }
        });
    },
  },

  mounted() {
    this.prepareStep5();
  },

  watch: {
    "form.firstName": function () {
      this.form.personGivingSIM = `${this.form.firstName} ${this.form.lastName}`;
    },
    "form.lastName": function () {
      this.form.personGivingSIM = `${this.form.firstName} ${this.form.lastName}`;
    },
    "form.address": function () {
      this.form.shopAddress = `${this.form.address} ${this.form.number}, ${this.form.postalCode} ${this.form.city}`;
    },
    "form.number": function () {
      this.form.shopAddress = `${this.form.address} ${this.form.number}, ${this.form.postalCode} ${this.form.city}`;
    },
    "form.postalCode": function () {
      this.form.shopAddress = `${this.form.address} ${this.form.number}, ${this.form.postalCode} ${this.form.city}`;
    },
    "form.city": function () {
      this.form.shopAddress = `${this.form.address} ${this.form.number}, ${this.form.postalCode} ${this.form.city}`;
    },
    "form.placeOfBuyingSIM": function () {
      this.form.shopName = this.form.placeOfBuyingSIM;
    },
  }
};
